import { Handle, Position, type NodeProps } from "@xyflow/react";

import type { GtmFlowNodeData } from "../sequenceToFlow";

export default function GtmStepNode({ data, selected }: NodeProps) {
  const d = data as GtmFlowNodeData;
  return (
    <div
      className={`nopan min-w-[140px] rounded-lg border bg-white px-3 py-2 shadow-sm ${
        selected ? "border-blue-500 ring-2 ring-blue-200" : "border-blue-200"
      }`}
    >
      <Handle type="target" position={Position.Left} className="!bg-slate-400" />
      <div className="flex items-start justify-between gap-2">
        <div>
          <div className="text-[10px] font-semibold uppercase tracking-wide text-blue-600">Step</div>
          <div className="text-sm font-medium text-gray-900">{d.label}</div>
          {d.subtitle ? <div className="text-xs text-gray-500">{d.subtitle}</div> : null}
        </div>
        {typeof d.count === "number" && d.count > 0 ? (
          <span className="rounded-full bg-blue-50 px-1.5 py-0.5 text-xs font-semibold text-blue-700">
            {d.count}
          </span>
        ) : null}
      </div>
      <Handle type="source" position={Position.Right} className="!bg-slate-400" />
    </div>
  );
}
